import {ADD_TRANSACTION_LOG, TRANSACTION_LOG_SEND_STARTED, TRANSACTION_LOG_SEND_FINISHED, TRANSACTION_LOG_SEND_FAILED} from 'constants/actionTypes';
export const addTransactionLog = (log) => ({type: ADD_TRANSACTION_LOG, log});

export const transactionLogSendStarted = (logs) => ({type: TRANSACTION_LOG_SEND_STARTED, logs});

export const transactionLogSendFinished = (payload, logs) => ({type: TRANSACTION_LOG_SEND_FINISHED, payload, logs});

export const transactionLogSendFailed = (payload) => ({type: TRANSACTION_LOG_SEND_FAILED, payload});


// WEBPACK FOOTER //
// ./src/actions/transactionLoggingActions.js